import _toConsumableArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { useCallback, useEffect, useMemo } from 'react';
import uniqueId from 'lodash.uniqueid';
import { OverlayManager } from '../util/OverlayManager';
import { getBody } from '../util/globals';
export var useOverlay = function useOverlay(open) {
  var parameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var id = useMemo(function () {
    return uniqueId();
  }, []);
  useEffect(function () {
    var body = getBody();

    if (open) {
      OverlayManager.pushOverlay(id, parameters);

      if (body && OverlayManager.hasWindowScrollBlock()) {
        body.style.overflowY = 'hidden';
      }
    }

    return function () {
      OverlayManager.removeOverlay(id);

      if (body && !OverlayManager.hasWindowScrollBlock()) {
        body.style.overflowY = 'visible';
      }
    };
  }, [id, open].concat(_toConsumableArray(Object.values(parameters))));
  var isTopOverlay = useCallback(function () {
    return OverlayManager.isTopOverlay(id);
  }, [id]);
  return {
    id: id,
    zIndex: OverlayManager.getOverlayZIndex(id),
    isTopOverlay: isTopOverlay
  };
};